import axios from './axios'
// import qs from "qs";

function service(endpoint) {
    function realized(id) {
        return axios.post(`${endpoint}/${id}/realized`).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        realized
    }
}

export default service
